module.exports = __webpack_public_path__ + "img/Pic_Title_LGA.7300c630.png";